<template>
    <div>
        <b-form-group
            class="mb-2"
            :label="inputLabel"
            :label-cols="inputLabel ? 4 : 0"
        >
            <b-input-group>
                <b-input-group-text slot="prepend">
                    {{ modeSymbol }}
                </b-input-group-text>
                <b-form-input
                    :id="inputId"
                    v-model="value_"
                    type="text"
                    :placeholder="inputPlaceholder"
                />
            </b-input-group>
            <b-form-invalid-feedback :force-show="inputInvalid">
                {{ inputValidationRequiredMessage }}
            </b-form-invalid-feedback>

            <b-form-checkbox
                v-model="fixed_"
                class="mt-2"
            >
                {{ checkboxLabel }}
            </b-form-checkbox>
            <div
                v-if="checkboxHint"
                slot="description"
            >
                {{ checkboxHint }}
            </div>
        </b-form-group>
    </div>
</template>

<script>
import { formatFloat } from '@/utils/helpers';

export default {

    props: {
        inputId: {
            type: String,
            default: null,
        },
        inputLabel: {
            type: String,
            default: null,
        },
        inputPlaceholder: {
            type: String,
            required: true,
        },
        inputInvalid: {
            type: Boolean,
            default: false,
        },
        inputValidationRequiredMessage: {
            type: String,
            required: true,
        },
        checkboxLabel: {
            type: String,
            required: true,
        },
        checkboxHint: {
            type: String,
            default: null,
        },
        value: {
            type: [String, Number],
            default: null,
        },
        fixed: {
            type: Boolean,
            default: false,
        },
    },

    data() {
        return {
            fixed__: this.fixed,
            value__: formatFloat(this.value, 2),
        };
    },

    computed: {
        value_: {
            get() {
                return this.value__;
            },
            set(val) {
                this.value__ = val;
                this.$emit('value', val);
                this.$emit('fixed', this.fixed__);
            },
        },
        fixed_: {
            get() {
                return this.fixed__;
            },
            set(val) {
                this.fixed__ = val;
                this.$emit('fixed', val);
            },
        },
        modeSymbol() {
            return this.fixed_ ? '£' : '%';
        },
    },

};
</script>
